import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import PDInvoiceIndia from "./PDInvoiceIndia";
import PDInvoiceGlobal from "./PDInvoiceGlobal";

export default function PDSubscriptionDetails({ data, onClose }) {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();
    const userId = authState?.user?._id;
    const status = data.subscriptionStatus;
    const countryCode = data.countryCode;
    const [showTaxPanel, setShowTaxPanel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
            const showMessage = (text, type = "success") => {
        setMessage({ text, type });
    };

    const [taxMeta, setTaxMeta] = useState([]);

    const fetchTaxMeta = async () => {
        setLoading(true);
        try {
            const config = {
                url: "/pd/taxmeta",
                method: "post",
                data: { countryCode },
                headers: { Authorization: authState.token },
            };
            const response = await fetchData(config, { silent: true });
            if (response?.status) {
                setTaxMeta(response.taxMeta || {});
            }
        } catch (err) {
            console.error("❌ Invoice Meta fetch error:", err);
            showMessage("Failed to load Invoice Meta", "error");
        }
        setLoading(false);
    };
    
    useEffect(() => {
        if (userId) fetchTaxMeta();
    }, [userId]);              
  
    return (
        <div className="bg-black/70 z-50 flex items-end">
            <div className="w-full bg-[#0b0f19] border-t border-gray-700 rounded-t-2xl p-4 max-h-[85vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-3">
                    <div className="text-cyan-400 font-bold text-sm">
                        Subscription Details
                    </div>
                    <button
                        onClick={onClose}
                        className="w-24 text-xs text-red-400"
                    >
                        Close
                    </button>
                </div>
                <div className="text-xs mb-3">
                    Status:{" "}
                    <span className="text-green-400 font-bold">
                        {status}
                    </span>
                </div>
                
                <div className="space-y-2 text-xs text-gray-100">
                    <div>Product: {data.product}</div>
                    <div>ID: {data.subscriptionId}</div>
                    <div>User: {data.userName}</div>
                    <div>Code: {data.userCode}</div>
                    <div>Country: {data.country}{" - " }{data.countryCode}</div>
                    <div>Start: {new Date(data.startDate).toLocaleString()}</div>
                    <div>End: {new Date(data.endDate).toLocaleString()}</div>
                    <div>Paid/Credits: {data.amountPaid}</div>
                    <div>Transaction: {data.transactionId}</div>
                    <div>Coordinator: {data.coordinatorCode}</div>
                    <div>Director: {data.directorCode}</div>
                    <div>Influencer: {data.influencerCode}</div>
                    <div>Institution: {data.institutionCode}</div>
                    <div>Mentor: {data.mentorCode}</div>
                </div>
                 <div className="mt-6">
                    {data.countryCode === "IN" ? (
                        <PDInvoiceIndia
                            subscription={data}
                            taxMeta={taxMeta}
                        />
                    ) : (
                        <PDInvoiceGlobal
                            subscription={data}
                            taxMeta={taxMeta}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}